import { Dialog } from "@constellation-academy/epic-ui";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { textWithPagesElementPageFormDialog_PageFragment$key } from "@relay/textWithPagesElementPageFormDialog_PageFragment.graphql";
import { PAGE_FRAGMENT } from "./text-with-pages-element-page-form-dialog.graphql";
import { TextWithPagesElementPageFormDialogProps } from "./text-with-pages-element-page-form-dialog.types";
import { TextWithPagesElementPageForm } from "../text-with-pages-element-page-form";

export const TextWithPagesElementPageFormDialog = ({
	textWithPagesElementPageFragmentRef,
	onHide,
	onSubmit,
	isVisible,
}: TextWithPagesElementPageFormDialogProps) => {
	const { t } = useTranslation("common");
	const page = useFragment<textWithPagesElementPageFormDialog_PageFragment$key>(
		PAGE_FRAGMENT,
		textWithPagesElementPageFragmentRef ?? null,
	);

	const dialogTitle = page
		? t("pages.editTitle", { title: page.internalTitle })
		: t("pages.createTitle");

	return (
		<Dialog visible={isVisible} onHide={onHide} title={dialogTitle}>
			<TextWithPagesElementPageForm
				textWithPagesElementPageFragmentRef={page}
				onSubmit={onSubmit}
				isCreating={!page}
			/>
		</Dialog>
	);
};
